import api from '../services/api';

export const adminAPI = {
  // ===== USER MANAGEMENT =====

  // Get business intelligence stats
  getStats: () => api.get('/admin/stats'),
  // Get admin action log for a user
  getUserActions: (userId) => api.get(`/admin/users/${userId}/actions`),
  // Set message limit override for a user
  setMessageOverride: (userId, override, reason) =>
    api.post(`/admin/users/${userId}/message-override`, { override, reason }),
  // Get recent admin actions across all users
  getRecentActions: () => api.get('/admin/actions/recent'),
  // Get reports & analytics data
  getReports: () => api.get('/admin/reports'),
  // Get all users
  getAllUsers: () => api.get('/admin/users'),

  // Get user details (includes deleted items within 15 days)
  getUserDetails: (userId) => api.get(`/admin/users/${userId}`),

  // Update user (any field)
  updateUser: (userId, updates) => api.put(`/admin/users/${userId}`, updates),

  // Update subscription specifically
  updateSubscription: (userId, plan) =>
    api.put(`/admin/users/${userId}/subscription`, { plan }),

  // Delete user
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),

  // Create new user
  createUser: (userData) => api.post('/admin/users', userData),

  // ===== SOFT DELETE MANAGEMENT =====

  // Restore deleted account
  restoreAccount: (userId) =>
    api.post(`/admin/users/${userId}/restore-account`, {}),

  // Restore deleted team
  restoreTeam: (userId, teamId) =>
    api.post(`/admin/users/${userId}/teams/${teamId}/restore`, {}),

  // Restore deleted graphic
  restoreGraphic: (userId, graphicId) =>
    api.post(`/admin/users/${userId}/graphics/${graphicId}/restore`, {}),

  // Restore deleted player
  restorePlayer: (userId, playerId) =>
    api.post(`/admin/users/${userId}/players/${playerId}/restore`, {}),

  // Permanently delete team
  permanentlyDeleteTeam: (userId, teamId) =>
    api.delete(`/admin/users/${userId}/teams/${teamId}`),

  // Permanently delete graphic
  permanentlyDeleteGraphic: (userId, graphicId) =>
    api.delete(`/admin/users/${userId}/graphics/${graphicId}`),

  // Permanently delete player
  permanentlyDeletePlayer: (userId, playerId) =>
    api.delete(`/admin/users/${userId}/players/${playerId}`),

  // ===== ANNOUNCEMENTS =====

  // Get all announcements
  getAllAnnouncements: () => api.get('/admin/announcements'),

  // Create announcement
  createAnnouncement: (announcementData) =>
    api.post('/admin/announcements', announcementData),

  // Update announcement
  updateAnnouncement: (id, announcementData) =>
    api.put(`/admin/announcements/${id}`, announcementData),

  // Toggle announcement active status
  toggleAnnouncement: (id) =>
    api.patch(`/admin/announcements/${id}/toggle`, {}),

  // Delete announcement
  deleteAnnouncement: (id) => api.delete(`/admin/announcements/${id}`),

  // ===== SEASONS =====

  // Get all seasons (admin view)
  getAllSeasons: () => api.get('/seasons'),

  // Get active seasons (for dropdowns)
  getActiveSeasons: () => api.get('/seasons/active'),

  // Create season
  createSeason: (seasonData) => api.post('/seasons', seasonData),

  // Update season
  updateSeason: (id, seasonData) => api.put(`/seasons/${id}`, seasonData),

  // Delete season
  deleteSeason: (id) => api.delete(`/seasons/${id}`),

  // Generate future seasons
  generateSeasons: (yearsAhead) =>
    api.post('/seasons/generate', { yearsAhead }),

  // ===== AGE GROUPS =====

  // Get all age groups (admin view - includes inactive)
  getAllAgeGroups: () => api.get('/agegroups/admin'),

  // Get active age groups (for dropdowns)
  getActiveAgeGroups: () => api.get('/agegroups'),

  // Create age group
  createAgeGroup: (ageGroupData) => api.post('/agegroups', ageGroupData),

  // Update age group
  updateAgeGroup: (id, ageGroupData) =>
    api.put(`/agegroups/${id}`, ageGroupData),

  // Delete age group
  deleteAgeGroup: (id) => api.delete(`/agegroups/${id}`),
};
